<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.43109 11.7549C2.38104 11.9121 2.38104 12.0812 2.43109 12.2383C3.72616 16.2847 7.52132 19.2171 11.995 19.2171C16.4688 19.2171 20.263 16.2847 21.559 12.2383C21.6091 12.0812 21.6091 11.9121 21.559 11.7549C20.263 7.70856 16.4688 4.77612 11.995 4.77612C7.52132 4.77612 3.72616 7.70856 2.43109 11.7549ZM4.02141 11.9961C5.18338 8.7144 8.31699 6.36044 11.995 6.36044C15.6731 6.36044 18.8057 8.7144 19.9687 11.9961C18.8057 15.2789 15.6731 17.6328 11.995 17.6328C8.31699 17.6328 5.18338 15.2789 4.02141 11.9961ZM11.995 7.99581C9.78721 7.99581 7.99472 9.78829 7.99472 11.9961C7.99472 14.204 9.78721 15.9965 11.995 15.9965C14.2029 15.9965 15.9954 14.204 15.9954 11.9961C15.9954 9.78829 14.2029 7.99581 11.995 7.99581ZM11.995 9.58112C13.3282 9.58112 14.4101 10.663 14.4101 11.9961C14.4101 13.3302 13.3282 14.4121 11.995 14.4121C10.6619 14.4121 9.57905 13.3302 9.57905 11.9961C9.57905 10.663 10.6619 9.58112 11.995 9.58112Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'EyeOpen'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
